import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import configRequest from '@api/requests/configRequest';

import TaxFormPdfInterface from './interfaces/TaxFormPdfInterface.interface';

export interface RecertifyW8BenData {
	application_id: number;
}

export interface RecertifyW8BenResponse {
	status: boolean;
	w8_pdf: TaxFormPdfInterface;
}

const recertifyW8BenForm = configRequest<RecertifyW8BenResponse, RecertifyW8BenData>({
	requestPrefix: 'applications/recertifyW8Ben',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.APPLICATIONS.RECERTIFY_W8_BEN(),
		method: HTTP_METHODS_ENUM.POST,
		data,
	}),
});

export const recertifyW8BenFormValidation = configRequest<RecertifyW8BenResponse, RecertifyW8BenData>({
	requestPrefix: 'applications/recertifyW8BenFormValidation',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.APPLICATIONS.RECERTIFY_W8_BEN(),
		method: HTTP_METHODS_ENUM.POST,
		data: {
			...data,
			only_validate: true,
		},
	}),
});

export default recertifyW8BenForm;
